import * as R from 'ramda';
import { omitBy, omitByDeep } from './omitBy';
export const cleanObject = omitBy(R.isNil);
export const cleanObjectDeep = omitByDeep(R.isNil);
